const homePathname = "/dashboard";
const username = "Imamuzzaki Abu Salam";
const profileImage = "/profile.jpeg";

export { homePathname, username, profileImage };
